import React from 'react'
import CommonMomentAndAttendance from '../commonfile/CommonMomentAndAttendance'

const ZoneManagerMomentAttendance = () => {
    return (
        <>
            <CommonMomentAndAttendance />
        </>
    )
}

export default ZoneManagerMomentAttendance